module.exports = __webpack_public_path__ + "img/icon_beijing.bb6ebe18.png";